import Unstable_Grid2 from '@mui/material/Unstable_Grid2';

export default Unstable_Grid2;
